export default "__VITE_ASSET__CoGCh00___"